import api from '../config/api';

const orderService = {
  async getAll(page = 1, pageSize = 10) {
    const response = await api.get('/api/orders', {
      params: { page, pageSize },
    });
    return response.data;
  },

  async getById(id) {
    const response = await api.get(`/api/orders/${id}`);
    return response.data;
  },

  async getByStatus(status, page = 1, pageSize = 10) {
    const response = await api.get('/api/orders', {
      params: { status, page, pageSize },
    });
    return response.data;
  },

  async search(filter) {
    const response = await api.post('/api/orders/search', filter);
    return response.data;
  },

  async updateStatus(orderId, newStatus, reason = null) {
    const response = await api.put(`/api/orders/${orderId}/status`, {
      status: newStatus,
      reason,
    });
    return response.data;
  },

  async getStatistics() {
    const response = await api.get('/api/orders/statistics');
    return response.data;
  },

  async getRecentActivities(count = 10) {
    const response = await api.get('/api/orders/recent-activities', {
      params: { count },
    });
    return response.data;
  },

  /**
   * Sales/revenue over time for charts. Returns [{ date, revenue, orderCount }, ...].
   * Backend may implement GET /api/orders/sales-over-time?from=&to=&groupBy=day
   */
  async getSalesOverTime(fromDate, toDate, groupBy = 'day') {
    const response = await api.get('/api/orders/sales-over-time', {
      params: { from: fromDate, to: toDate, groupBy },
    });
    return response.data;
  },
};

export default orderService;
